import axios from "axios";
import { onlineManager } from "@tanstack/react-query";
import { guardNetworkRequest } from "./network";

// Install before importing app clients, including Reown's additional RPC fallbacks.
const nativeFetch = globalThis.fetch.bind(globalThis);
const nativeAdapter = axios.defaults.adapter;
globalThis.fetch = guardNetworkRequest(nativeFetch);
axios.defaults.adapter = guardNetworkRequest(axios.getAdapter(nativeAdapter));
onlineManager.setOnline(navigator.onLine);

if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    globalThis.fetch = nativeFetch;
    axios.defaults.adapter = nativeAdapter;
  });
}
